class StorageService {

    getObjectLocalStorage = (key) => {
        const item = localStorage.getItem(key);
        if (item !== null) {
            return JSON.parse(item);
        }

        return null;
    }

    getItemLocalStorage = (key) => {
        return localStorage.getItem(key);
    }

    saveItemLocalStorage = async(key, item) => {
        return localStorage.setItem(key, item)
    }

    saveObjectLocalStorage = (key, item) => {
        return localStorage.setItem(key, JSON.stringify(item));
    }

    setMenuOption = (open) => {
        return localStorage.setItem('menu', open);
    }

    getMenuOption = () => {
        return localStorage.getItem('menu') === 'true';
    }

    clearAllStorage = () => {
        return localStorage.clear();
    }

}

export default StorageService;